import { render, staticRenderFns } from "./HotbList.vue?vue&type=template&id=60195a1c&scoped=true&"
import script from "./HotbList.vue?vue&type=script&lang=js&"
export * from "./HotbList.vue?vue&type=script&lang=js&"
import style0 from "./HotbList.vue?vue&type=style&index=0&id=60195a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60195a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60195a1c')) {
      api.createRecord('60195a1c', component.options)
    } else {
      api.reload('60195a1c', component.options)
    }
    module.hot.accept("./HotbList.vue?vue&type=template&id=60195a1c&scoped=true&", function () {
      api.rerender('60195a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/HotbList.vue"
export default component.exports